import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed0bcde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"author-title\" data-v-2ed0bcde>About the Author</span><div class=\"author-image\" data-v-2ed0bcde></div><span class=\"name\" data-v-2ed0bcde>Montana Gau</span><span class=\"field\" data-v-2ed0bcde>Software Engineer</span><p class=\"bio\" data-v-2ed0bcde> Software engineer with a focus on web engineering. My guides include anything pertaining to tech and engineering. </p>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_7))
}